import React, {memo} from 'react';
import {onClickHandler} from '../../utils/onclick';

import './index.scss';

type CheckBoxProps = {
    set: () => void;
    value: boolean;
};

export const CheckBox = memo(function SettingCheckBoxComponent({set, value}: CheckBoxProps) {
    return <div {...onClickHandler(set)} className={'checkmark' + (value ? ' checked' : '')}/>
});
